import type { FC } from "react";

/**
 * One label-and-value pair. The report is read, not scanned, so figures sit in a
 * column with the label above the value rather than in a table an owner would
 * have to line up by eye.
 */
export const Figure: FC<{ label: string; value: string }> = ({
  label,
  value
}) => (
  <div className="flex flex-col gap-0.5">
    <span className="text-xs text-content-400">{label}</span>
    <span className="text-base font-medium text-content-1000">{value}</span>
  </div>
);
